module.exports = __webpack_public_path__ + "img/home_city_icon1.66339e5.png";